import {
    Box,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useSelector } from 'react-redux'
import { selectUserToken } from '../../../../../features/userSlice'
import ReceiptDiscussionTabs from './ReceiptDiscussionTabs/ReceiptDiscussionTabs'
import { ReceiptsEndPointLogic } from '../../../../../logic/Finance/ProviderExpense/ReceiptsEndpointLogic'
import { useEffect } from 'react'

export default function ReceiptDiscussion() {
    const oauthTokenHeader = useSelector(selectUserToken) as string
    const getUserList = async (oauthTokenHeader: string) => {
        await ReceiptsEndPointLogic.getAllUserList(oauthTokenHeader)
    }

    useEffect(() => {
        if (!oauthTokenHeader) return
        getUserList(oauthTokenHeader)
    }, [oauthTokenHeader])
    return (
        <Box mt={2} mb={2}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ minHeight: '48px !important' }}
                >
                    <Typography component="span" sx={{ fontSize: '18px' }}>
                        Discussion
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <ReceiptDiscussionTabs />
                </AccordionDetails>
            </Accordion>
        </Box>
    )
}
